import iconPath from 'assets/img/paw-icon.svg'
import addAlpha from '../utils/add-alpha'

const globalSettings = {
  iconPath,
  fonts: {
    default:
      'Inter, -apple-system, BlinkMacSystemFont, Avenir Next, Avenir, Helvetica, sans-serif',
    mono: 'JetBrains Mono, sans-serif',
  },
  radii: {
    default: '6px',
    focused: '6px',
    tag: '100px',
  },
  spacing: {
    defaultMargin: '12px',
  },
  fontSizes: {
    title: 48,
    headline: 24,
    body1: 16,
    body2: 14,
    caption: 12,
    caps: 12, // @TODO: legacy
  },
  fontWeights: {
    normal: 400,
    bold: 600,
  },
  lineHeights: {
    title: '56px',
    headline: '32px',
    body1: '24px',
    body2: '20px',
    captionMono: '16px',
    caption: '16px',
    caps: '18px', // @TODO: legacy
  },
  letterSpacings: {
    title: 'normal',
    headline: 'normal',
    body1: 'normal',
    body2: 'normal',
    captionMono: 'normal',
    caption: 'normal',
    caps: '0.06em', // @TODO: legacy
  },
  space: [0, 4, 8, 12, 16, 24, 32, 48],
  sizes: {
    default: {
      py: 6,
    },
    large: {
      py: 8,
    },
  },
  typography: {
    title: {
      fontFamily: 'default',
      fontSize: 'title',
      lineHeight: 'title',
      letterSpacing: 'title',
    },
    headline: {
      fontFamily: 'default',
      fontSize: 'headline',
      lineHeight: 'headline',
      letterSpacing: 'headline',
    },
    body1: {
      fontFamily: 'default',
      fontSize: 'body1',
      lineHeight: 'body1',
      letterSpacing: 'body1',
    },
    body2: {
      fontFamily: 'default',
      fontSize: 'body2',
      lineHeight: 'body2',
      letterSpacing: 'body2',
    },
    caption: {
      fontFamily: 'default',
      fontSize: 'caption',
      lineHeight: 'caption',
      letterSpacing: 'caption',
    },
    captionMono: {
      fontFamily: 'default',
      fontSize: 'captionMono',
      lineHeight: 'captionMono',
      letterSpacing: 'captionMono',
    },
    // @TODO: legacy
    caps: {
      fontFamily: 'default',
      fontSize: 'caps',
      lineHeight: 'caps',
      letterSpacing: 'caps',
      textTransform: 'uppercase',
    },
  },
  addAlpha,
}

export default globalSettings
